import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatName',
  standalone: true,
})
export class FormatNamePipe implements PipeTransform {
  transform(name: string): string {
    if (!name) {
      return '';
    }

    const trimmed = name.trim();

    if (trimmed.includes(' ')) {
      return trimmed;
    }

    const parts = trimmed.match(/[A-Z][a-z]+/g);

    if (parts && parts.length >= 2) {
      return parts.join(' ');
    }

    return trimmed;
  }
}
